import { getDvaApp } from 'umi';
import {fetch} from 'dva'
import { Modal, message } from 'antd'
import formurlencoded from 'form-urlencoded'
import Cookies from 'universal-cookie'

export default async function request(url, options = {}) {
  const cookies = new Cookies()
  const token = cookies.get('access_token')

  options.method = options.method || 'GET'  // eslint-disable-line
  options.method = options.method.toUpperCase()  // eslint-disable-line

  const requestOptions = { method: options.method }

  let GetLike = false
  let targetUrl = url

  const headers = new Headers()

  headers.append('Authorization', `bearer ${token}`)

  if (options.method === 'GET') { GetLike = true }

  if (GetLike && options.data) {
    targetUrl += `?${formurlencoded(options.data)}`
  } else {
    if (!options.headers && options.type !== 'file') {
      headers.append('Content-Type', 'application/json;charset=utf-8')
      requestOptions.body = JSON.stringify(options.body||options.data)
    } else {
      requestOptions.body = options.body || options.data;
    }
  }

  requestOptions.headers = headers

  const response = await fetch(targetUrl, requestOptions)
  const data = await response.json()

  if (response.status === 403) {
    const dvaApp = getDvaApp()
    Modal.error({
      title: 'ERROR',
      content: '登录信息失效，请重新登录',
      onOk() {
        dvaApp._store.dispatch({type: 'app/logout'})
      },
    })
  } else if (response.status === 400) {
    const msg = _.get(data, 'message')
    message.error(msg)
  }

  return data
}
